import _omit from 'lodash/omit';
import { Values } from '@lib/interfaces/form';

export default function getSiteAreaPreparedDataFromValues(values: Values) {
  return {
    ..._omit(values, 'id', '__typename', 'code', 'fullCode'),
  };
}
